module.exports = __webpack_public_path__ + "img/coconut.97be1a29.svg";